import { createContext } from 'react';

export interface PaymentMethodCard {
  brand: string;
  last4: string;
  exp_month: number;
  exp_year: number;
}

export interface PaymentMethod {
  id: string;
  card: PaymentMethodCard;
  [key: string]: unknown;
}

export interface CardContextType {
  paymentMethods: PaymentMethod[] | undefined;
  selectedCard: PaymentMethod | null;
  setPrimaryCard: (card: PaymentMethod) => void;
  fetchCardDetails: (id: string) => void;
  removeCardDetails: (id: string) => void;
}

export const CardContext = createContext<CardContextType>({} as CardContextType);

